import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from './ui/AnimatedSection';
import { Target, MessageSquare, Zap, Gift, Sparkles } from 'lucide-react';
const bonuses = [{
  icon: Target,
  title: 'Plantillas terapéuticas',
  desc: 'Registro de pensamientos, ejercicios guiados y checklists emocionales',
  value: '$9.990'
}, {
  icon: MessageSquare,
  title: 'Conversaciones internas guiadas',
  desc: 'Qué decirte en momentos de ansiedad y cómo destrabar tu mente',
  value: '$7.990'
}, {
  icon: Zap,
  title: 'Rutinas de calma mental',
  desc: 'Protocolos rápidos para momentos críticos y ejercicios de aplicación inmediata',
  value: '$8.990'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    scale: 1
  }
};
export function Bonuses() {
  return <AnimatedSection className="bg-navy text-white py-12 md:py-16 relative overflow-hidden" data-id="element-13">
      {/* Background sparkle effect */}
      <div className="absolute top-10 left-10 w-32 h-32 bg-orange/5 rounded-full blur-2xl pointer-events-none" data-id="element-14"></div>
      <div className="absolute bottom-10 right-10 w-40 h-40 bg-orange/5 rounded-full blur-2xl pointer-events-none" data-id="element-15"></div>

      <div className="text-center mb-10 relative z-10" data-id="element-16">
        <motion.div initial={{
        scale: 0
      }} whileInView={{
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 15
      }} className="inline-flex items-center gap-2 bg-orange text-white text-sm font-bold uppercase tracking-wider px-4 py-2 rounded-full mb-4" data-id="element-17">
          <Gift size={16} data-id="element-18" />
          <span data-id="element-19">GRATIS solo por hoy</span>
        </motion.div>

        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-2" data-id="element-20">
          + 3 Bonos Exclusivos
        </h2>
        <p className="text-gray-400 text-sm md:text-base" data-id="element-21">
          Valorados en{' '}
          <span className="text-orange font-bold line-through" data-id="element-22">$26.970</span> —{' '}
          <span className="text-green-400 font-bold" data-id="element-23">
            hoy los llevás GRATIS
          </span>
        </p>
      </div>

      <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true
    }} className="grid grid-cols-1 md:grid-cols-3 gap-5 relative z-10" data-id="element-24">
        {bonuses.map((bonus, idx) => {
        const Icon = bonus.icon;
        return <motion.div key={idx} variants={cardVariants} whileHover={{
          y: -6,
          boxShadow: '0 12px 40px rgba(232,131,58,0.2)'
        }} className="bg-navy-light rounded-2xl p-6 border border-orange/20 text-center relative overflow-hidden group cursor-default hover:border-orange/50 transition-colors" data-id="element-25">
              {/* Bonus number ribbon */}
              <div className="absolute top-0 left-0 bg-orange text-white font-bold text-xs py-1 px-3 rounded-br-xl" data-id="element-26">
                BONO {idx + 1}
              </div>

              {/* Crossed out value */}
              <div className="absolute top-2 right-3" data-id="element-27">
                <span className="text-gray-500 text-xs line-through" data-id="element-28">
                  {bonus.value}
                </span>
                <span className="text-green-400 text-xs font-bold ml-1" data-id="element-29">
                  GRATIS
                </span>
              </div>

              <div className="inline-flex bg-orange/10 p-4 rounded-full mb-4 mt-4 group-hover:bg-orange/20 transition-colors relative" data-id="element-30">
                <Icon size={28} className="text-orange" data-id="element-31" />
                <Sparkles size={14} className="text-orange absolute -top-1 -right-1 animate-pulse" data-id="element-32" />
              </div>

              <h3 className="font-heading font-bold text-lg mb-3" data-id="element-33">
                {bonus.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-34">
                {bonus.desc}
              </p>

              {/* Bottom accent line */}
              <div className="absolute bottom-0 left-0 w-full h-1 bg-orange/0 group-hover:bg-orange transition-colors duration-300" data-id="element-35"></div>
            </motion.div>;
      })}
      </motion.div>
    </AnimatedSection>;
}